import { IntegrationType } from '@floori/models';

export interface IntegrationState {
    integrationType: IntegrationType;
}

export const initialIntegrationState: IntegrationState = {
    integrationType: IntegrationType.floori,
} as const;
